import 'babel-polyfill';
import 'angular';
import * as Raven from 'raven-js';
import * as RavenAngular from 'raven-js/plugins/angular';
import environment from '../environment';

Raven.config(environment.sentryDSN, {
  shouldSendCallback() {
    return environment.prod;
  }
}).addPlugin(RavenAngular, angular)
  .install();

Raven.setUserContext({
  email: window.localStorage.getItem('arc.email'),
  username: window.localStorage.getItem('arc.username')
});

Raven.setExtraContext({
  authority: window.localStorage.getItem('arc.authority'),
  environment: window.localStorage.getItem('arc.environment'),
  groups: window.localStorage.getItem('arc.groups'),
  organization: window.localStorage.getItem('arc.organization')
});
